//#region React Imports
import React, { useState } from 'react';
import { Col, Row } from "react-bootstrap";
//#endregion

//#region MUI Imports
import {Box, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent, IconButton, Stack} from '@mui/material';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import CloseIcon from '@mui/icons-material/Close';
//#endregion

//#region CSS Imports
import "../../css/serviceapp/service-selection.css";
import {TemplateDto} from "../../helpers/dtos/TemplateDto";
//#endregion

//#region Interfaces
// Props Interface for ServiceSelection component
interface ServiceSelectionProps {
    Templates: TemplateDto[];
    AddButtonBehavior: (templateId: string) => void;
    CancelButtonBehavior: () => void;
}
//#endregion

// Component function "ServiceSelection"
export default function ServiceSelection(Props: ServiceSelectionProps) {
    const [selectedTemplate, setSelectedTemplate] = useState('');

    const handleChange = (event: SelectChangeEvent) => {
        setSelectedTemplate(event.target.value as string);
    };

    return (
        <Row className={"service-selection justify-content-md-center"}>
            <Row className={"service-selection-text justify-content-md-center"}>
                <Col xs={{span:6}}>
                    <Box className={"service-selection-text-data"}>
                        Create a new service with a template
                    </Box>
                </Col>
            </Row>
            <Row className={"service-selection-options justify-content-md-center"}>
                <Col className={"service-selection-options-data"} xs={{span:3, offset:1}}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Templates</InputLabel>
                        <Select
                            className="service-selection-options-options"
                            value={selectedTemplate}
                            label="Sheepgate Templates"
                            onChange={handleChange}>
                            {
                                Props.Templates.map((template: TemplateDto) => {
                                    return (
                                        <MenuItem key={template.id} value={template.id} className={"service-selection-options-items"}>
                                            {template.name}
                                        </MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                </Col>
                <Col className={"service-selection-buttons"} xs={{span:2}}>
                    <Stack direction="row">
                        <IconButton
                            className={"add-button"}
                            aria-label="add icon"
                            onClick={() => Props.AddButtonBehavior(selectedTemplate)}>
                            <AddBoxOutlinedIcon/>
                        </IconButton>
                        <IconButton
                            className={"cancel-button"}
                            aria-label="cancel icon"
                            onClick={Props.CancelButtonBehavior}>
                            <CloseIcon/>
                        </IconButton>
                    </Stack>
                </Col>
            </Row>
        </Row>
    );
}